import {forwardRef} from "react";
import {projectApi} from "~/api";
import {DebounceSelect} from "../index";

const SelectProject = forwardRef(({ options, errors, ...props }, ref) => {

	const onSearchCustomer = async (keyword, service) => {
		const response = await projectApi.search({keyword});
		return response.data.map((project) => ({
			label: `HD${project.contractId} ${project.name}`,
			value: project.id,
		}))
	}

	return (
		<DebounceSelect fetchOptions={(keyword) => onSearchCustomer(keyword)} errors={errors} optionsDefault={options} {...props} ref={ref}/>
	)
});

export default SelectProject;